import state from './state'

const allDataSet = function() {
    for (let i = 0; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if (
            currentObj.quantity === '' ||
            currentObj.discountType === '' ||
            currentObj.discount === ''
        ) {
            return false
        }
    }
    return true
}

const allDataValid = function() {
    if (state.arrayDiscounts.length === 0) {

        return false
    }
    // ANTES DE TODO ESTO SE DEBERÍA LLAMAR A UNA FUNCIÓN QUE ORDENE POR CANTIDAD
    let appliedDiscount = applyDiscount()
    let firstObj = state.arrayDiscounts[0]
    let firstOk = false
    if (firstObj.quantity === '' || firstObj.discountType === '' || firstObj.discount === '') {
        return false
    } else if (appliedDiscount[0] >= state.maxPriceDiscount) {
        return false
    } else if(state.arrayDiscounts.length === 1){
        return true
    }

    
    // let prevObj = firstObj
    for (let i = 1; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if (
            currentObj.quantity === '' ||
            currentObj.discountType === '' ||
            currentObj.discount === '' ||
            // prevObj.quantity >= currentObj.quantity ||
            //parseInt(prevObj.discount) >= parseInt(currentObj.discount)
            appliedDiscount[i-1] <= appliedDiscount[i]
        ) {
            return false
        }
        // prevObj = currentObj
    }
    return true
}

const verifiedQuantities = function() {
    if(state.arrayDiscounts.length === 0) return true

    let prevObj = state.arrayDiscounts[0]
    if(prevObj.quantity === '') return false

    for (let i = 1; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if (currentObj.quantity === '' ||
            parseInt(prevObj.quantity) >= parseInt(currentObj.quantity)) return false
        prevObj = currentObj
    }
    return true
}

const quantitiesSorted = function(){ // TODO parece que hace lo mismo que verifiedQuantities (revisar de ahí)
    if(state.arrayDiscounts.length === 0 || state.arrayDiscounts.length === 1) return true
    if(verifiedQuantities()) return true
    for (let i = 1; i < state.arrayDiscounts.length; i++) {
        if(parseInt(state.arrayDiscounts[i-1].quantity) > parseInt(state.arrayDiscounts[i].quantity) ){
            return false
        }
    }

    return true
}



const applyDiscount = function() {
    let appliedDiscount = []

    for (let i = 0; i < state.arrayDiscounts.length; i++) {
        let currentDiscountData = state.arrayDiscounts[i]
        let discount = 0
        if (currentDiscountData.discount != '' && currentDiscountData.discount != null) {
            if (currentDiscountData.discountType === 1) { // Porcentaje
                discount = state.maxPriceDiscount * parseInt(currentDiscountData.discount) / 100
                discount = parseInt(discount, 10)
            } else if (currentDiscountData.discountType === 2) {// Precio
                discount = parseInt(currentDiscountData.discount)
            } else {
                discount = 0
            }
        }
        appliedDiscount.push(state.maxPriceDiscount - discount)
    }

    return appliedDiscount
}

const discountsSorted = function(){
    let appliedDiscount = applyDiscount()
    if(appliedDiscount.length === 0 || appliedDiscount.length === 1) return true

    for (let i = 1; i < appliedDiscount.length; i++) {
        if(appliedDiscount[i-1] <= appliedDiscount[i] ){
            return false
        }
    }
    return true
}

const lengthArrayDiscounts = function() {
    return state.arrayDiscounts.length
}
const allQuantitiesSet = function(){
    for (let i = 0; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if(currentObj.quantity === '') return false
    }
    return true
}

const allDiscountsTypeSet = function(){
    for (let i = 0; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if(currentObj.discountType === '') return false
    }
    return true
}
const allDiscountsSet = function(){
    for (let i = 0; i < state.arrayDiscounts.length; i++) {
        let currentObj = state.arrayDiscounts[i]
        if(currentObj.discount === '') return false
    }
    return true
}
const arrayValidations = function() {
    let validationsList = []

    if(allDataValid()) return validationsList

    let currentId = 0

    if(!allDataSet()){
        let validation = { id: currentId, text: 'FALTA COMPLETAR CAMPOS'}
        validationsList.push(validation)
        currentId++
    }

    if(!allQuantitiesSet()){
        let validation = { id: currentId, text: 'No puede dejar el campo de cantidades vacío'}
        validationsList.push(validation)
        currentId++
    }else if(!quantitiesSorted()){
        let validation = { id: currentId, text: 'Debe ordenar de menor a mayor las cantidades de los esquemas'}
        validationsList.push(validation)
        currentId++
    }

    if(!allDiscountsTypeSet()){
        let validation = { id: currentId, text: 'Debe elegir un tipo de descuento para cada esquema'}
        validationsList.push(validation)
        currentId++
    }else if(!allDiscountsSet()){
        let validation = { id: currentId, text: 'No puede dejar el campo de descuento vacío'}
        validationsList.push(validation)
        currentId++
    }else if(quantitiesSorted() && !discountsSorted()){
        
        let validation = { id: currentId, text: 'Los descuentos debe ordenarlos de menor a mayor'}
        validationsList.push(validation)
        currentId++
    }

    console.log('validationsList', validationsList)
    return validationsList

}

export default {
    allDataSet,
    lengthArrayDiscounts,
    applyDiscount,
    allDataValid,
    quantitiesSorted,
    discountsSorted,
    arrayValidations,
    verifiedQuantities,
}
